import { createContext, useContext } from 'react';

const DeviceContext = createContext<Record<'isMobile' | 'isApp', boolean>>({ isMobile: false, isApp: false });

function useDevice() {
  return useContext(DeviceContext);
}

export { DeviceContext, useDevice };
